import { Tooltip } from "@mui/material";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function AutoTooltipInfo(props) { if (!props.value) {
    return /*#__PURE__*/ _jsx(_Fragment, { children: props.children });
} return /*#__PURE__*/ _jsx(Tooltip, { title: props.value, children: props.children }); }
